import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import PatientCard from '../organisms/PatientCard';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row, Col, Spinner } from 'react-bootstrap';
import { RootState } from '../../redux/rootReducer';
import { checkAuthState } from '../../redux/slices/authSlice';
import { ThunkDispatch, Action } from '@reduxjs/toolkit';
import { Badge, Patient, Session, Sex, Device } from '../../types';
import { fetchDevicesWithVitals, selectDevices, selectDevicesLoading, selectDevicesError, fetchDevicesWithVitalsData } from '../../redux/slices/devices';
import websocketService from '../../services/websocketService';
import DogError from '../organisms/Error';
import ControlPanel from '../organisms/VitalsControlPanel';
import ManualVitalsForm, { ManualVitalsData } from '../organisms/ManualVitalsForm';
import { toast } from "react-toastify";
import { saveManualVitals } from "../molecules/api";

const defaultPatient: Patient = {
  id: "",
  customerId: "--",
  species: '--',
  breed: 'house',
  name: "<session not started>",
  sex: Sex.FEMALE_SPAYED,
  doctor: '--',
  phone: '--',
}
const defaultBadge: Badge = {
  color: "pink",
  number: "--",
  location: "--"
}
const defaultSession: Session = {
  id: "",
  startTime: ""
}

const Vitals: React.FC = () => {
  const { deviceId } = useParams();
  const dispatch = useDispatch<ThunkDispatch<RootState, void, Action>>()
  const { user, isAuthenticated } = useSelector((state: RootState) => state.auth);
  const devices = useSelector(selectDevices);
  const loading = useSelector(selectDevicesLoading);
  const error = useSelector(selectDevicesError);

  const handleDeviceUpdate = () => {
    dispatch(fetchDevicesWithVitals());
  };


  useEffect(() => {
    dispatch(checkAuthState());
  }, [dispatch]);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(fetchDevicesWithVitals());
    }
  }, [dispatch, isAuthenticated]);

  const handleVitalsSubmit = (data: ManualVitalsData) => {
    console.log("Manual Vitals Submitted:", data);
    saveManualVitals(data)
      .then((response) => {
        console.log("Vitals saved successfully:", response);
        toast.success("Vitals saved");
      }).catch((error) => {
        console.error("Error saving vitals:", error);
        toast.error("Error saving manual vitals");
      });
  };



  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }
    if (!user) {
      return;
    }
    if (user && !user.token) {
      return;
    }
    if (!deviceId) {
      return;
    }
    if (devices.length < 1) {
      return;
    }
    const jwt = user.token;
    if (jwt) {
      websocketService.connect(jwt);
      websocketService.joinRoom(deviceId);
    }

    return () => {
      websocketService.disconnect();
    };
  }, [isAuthenticated, user, devices]);

  const device = devices.find((device) => device.id === deviceId);

  if (!deviceId) {
    return (
      <DogError missing="Device Id" />
    );
  }

  if (!device) {
    return (
      <DogError missing="Device" />
    );
  }

  if (!isAuthenticated || loading) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  }

  const session = device?.session || { ...defaultSession }
  const aPatient = session?.patient || { ...defaultPatient };
  const aBadge = { ...defaultBadge };
  if (device.colorCode) {
    aBadge.color = device.colorCode;
    aBadge.location = device.colorCode;
  }
  if (device.inClinicLocation) {
    aBadge.location = device.inClinicLocation;
  }
  if (device.name) {
    aBadge.location = device.name;
  }
  if (device.inClinicLocationNumber) {
    aBadge.number = `${device.inClinicLocationNumber}`;
  }


  console.log("aPatient", aPatient);
  return (
    <div className="container mt-5">
      <div className="row">
        <div className="col-md-8">
          <div className='row'>
            <div className='col-md-12'>
              <PatientCard
                sessionId={session.id}
                patient={aPatient}
                badge={aBadge}
                deviceId={deviceId}
                onOpenOverlay={() => {
                }}
              />
            </div>
          </div>
          <div className='row mt-1'>
            <div className='col-md-12'>
              <ManualVitalsForm onSubmit={handleVitalsSubmit} deviceId={deviceId} sessionId={session.id} patientId={aPatient.id}/>
            </div>
          </div>
        </div>
        <div className='col-md-4'>
          <ControlPanel onAddPatient={() => {
            handleDeviceUpdate();
          }} onEditDevice={() => {
            handleDeviceUpdate();
          }} onPauseSession={() => { }}
            onRemovePatient={() => {
              handleDeviceUpdate();
            }} onViewStatistics={() => { }}
            hasPatient={!!aPatient.id} deviceId={deviceId}
            sessionId={session.id} patientId={aPatient.id} />
        </div>
      </div>
    </div>
  );
};

export default Vitals;
